import { render, staticRenderFns } from "./commonUpload.vue?vue&type=template&id=55cfc27b&scoped=true"
import script from "./commonUpload.vue?vue&type=script&lang=js"
export * from "./commonUpload.vue?vue&type=script&lang=js"
import style0 from "./commonUpload.vue?vue&type=style&index=0&id=55cfc27b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cfc27b",
  null
  
)

export default component.exports